//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default {
      name: 'Myconfirm',
      data() {
        return {
          isShowConfirm: false, // 用于控制整个窗口的显示/隐藏
          content: '', // 提示框的内容
          cancelText: '取消', // 取消按钮的文字
          confirmText: '确认', // 确认按钮的文字
          type: '2', // 表明弹框的类型：2 - 确认弹窗（有取消按钮）；1 - 通知弹框（没有取消按钮）
          outerData: null, // 用于记录外部传进来的数据，也可以给外部监听userBehavior，事件的函数提供判断到底是哪个事件触发的
        }
      },
      methods: {
        show(content, config) {
          this.content = content || 'Say Something ...'

          if (Object.prototype.toString.call(config) === '[object Object]') {
            // 确保用户传递的是一个对象
            this.cancelText = config.cancelText || '取消'
            this.confirmText = config.confirmText || '确认'
            this.type = config.type || 'confirm'
            this.outerData = config.data || null
          }

          this.isShowConfirm = true
        },
        hidden() {
          this.isShowConfirm = false
          this.cancelText = '取消'
          this.confirmText = '确认'
          this.type = 'confirm'
          this.outerData = null
        },
        clickFun() {
          this.$emit('getAction', this.outerData)
          this.hidden()
        },
        cancel() {
          this.hidden()
        },
      },
    }



// WEBPACK FOOTER //
// ./client/components/Common/Myconfirm.vue